import React, {useState} from 'react';
import { Container, Button, Box, Dialog, DialogTitle, DialogContent, DialogActions, Stack, Typography, TextField, MenuItem, FormControlLabel, Switch} from '@mui/material';
import ImageUpload from './productImageUpload'

const classes  = {
  body:{
    width:'100%',
    display:'flex',
    flexDirection: 'row'
  },
  right: {
    width: '30%'
  },
  rowcont :{
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  innerright: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column'
  },
  textEl: {
    marginBottom:'10px'
  }
};

export default function CustomizedDialogs(props) {
    const [sku, setSku] = useState('');
    const [purchasePrice, setPurchasePrice] = useState(0);
    const [isAvailable, setIsAvailable] = useState(true);
    const [cropOpen, setCropOpen] = useState(false)
    const [itemPhoto, setItemPhoto] = useState()
    const [itemUrl, setItemUrl] = useState()
    const [invoiceUrl, setInvoiceUrl] = useState()
    const [invoicePhoto, setInvoicePhoto] = useState()
    const [boxPhotos, setBoxPhotos] = useState([{url:"", photo:""}])
    const saveTitle = props.editableItem ? 'Update Changes' : 'Save Item';
    const saveFunc = props.editableItem ? props.editItem : props.addItem;
    const [deletedImages, setDeletedImages] = useState({
                        invoiceImage:false,
                        itemImage:false,
                        boxImages:[]
                      })

    React.useEffect(()=>{
      if (props.editableItem) {
          console.log(props.editableItem)
            setFields(props.editableItem);
          }    
    }, [props.editableItem])
    React.useEffect(()=>{
      if (!props.editableItem && props.addItemOpen) {
        resetFields();
      }
    }, [props.addItemOpen, props.editableItem])
    const resetFields = () => {
        setSku('')
        setIsAvailable(true)
        setPurchasePrice(0)
        setInvoicePhoto()
        setItemPhoto()
        setInvoiceUrl()
        setItemUrl()
        setBoxPhotos([{url:"", photo:""}])
        setDeletedImages({
                        invoiceImage:false,
                        itemImage:false,
                        boxImages:[]
                      })
    }
    
    const setFields = (data) => {
      setSku(data.sku)
      setIsAvailable(data.isAvailable)
      setPurchasePrice(data.purchasePrice)
      setItemUrl(data.image?.item?.url)
      setInvoiceUrl(data.image?.invoice?.url)
      let boxImgs = [{url:"", photo:""}]
      if (Array.isArray(data.image?.boxImages) && data.image?.boxImages?.length > 0) {
        boxImgs.unshift(...data.image?.boxImages.map(img => ({url: img.url})))
        if (boxImgs.length > 4) {
            boxImgs.splice(1, 5)
        }

      }
      setBoxPhotos(boxImgs)
       setDeletedImages({
                        invoiceImage:false,
                        itemImage:false,
                        boxImages:[]
                      })
  }
  
    const handleAddProductClose = (e) => {
        props.addItemClose()(e);
        resetFields()
    }
    const handleClick =()=> { 
        return (e) => {
            const formData = new FormData();

            if (sku) {
                let data = {};
                if (props.editableItem) {
                    if (props.editableItem.sku !== sku) {
                        data.sku = sku; 
                    }
                    if (props.editableItem.purchasePrice !== purchasePrice) {
                        data.purchasePrice = purchasePrice; 
                    }
                    if (props.editableItem.isAvailable !== isAvailable) {
                        data.isAvailable = isAvailable; 
                    }
                    formData.append("data", JSON.stringify({sku: sku, productId: props.selectedProduct, purchasePrice: purchasePrice, isAvailable: isAvailable, deletedImages:deletedImages}))
                    if (itemPhoto) {
                        formData.append("itemImage", itemPhoto);
                    }
                    if (invoicePhoto) {
                        formData.append("invoiceImage", invoicePhoto);
                    }
                    
                    if (Array.isArray(boxPhotos) && boxPhotos.length > 0) {
                        boxPhotos.forEach(_boxPhoto => {
                            if (_boxPhoto.photo) {
                                console.log(_boxPhoto.photo)
                                formData.append("boxImages", _boxPhoto.photo)
                            }
                        })
                    }
                } else {
                    formData.append("data", JSON.stringify({sku: sku, productId: props.selectedProduct, purchasePrice: purchasePrice, isAvailable: isAvailable}))
                    
                    if (itemPhoto) {
                        formData.append("itemImage", itemPhoto);
                    }
                    if (invoicePhoto) {
                        formData.append("invoiceImage", invoicePhoto);
                    }
                    
                    if (Array.isArray(boxPhotos) && boxPhotos.length > 0) {
                        boxPhotos.forEach(_boxPhoto => {
                            if (_boxPhoto.photo) {
                                console.log(_boxPhoto.photo)
                                formData.append("boxImages", _boxPhoto.photo)
                            }
                        })
                    }
                }
                saveFunc(formData, props?.editableItem?._id)
                //resetFields();
            } else {
                console.log('Mandatory details required');
            }
        }
    }

    const handleBoxPhotosChange = (index) =>{
        return (file) => {
            const _boxPhotos = [...boxPhotos]
            if (_boxPhotos[index]) {
                _boxPhotos[index].url = file
                _boxPhotos[index].photo = file
                if (_boxPhotos.length < 4) {
                    _boxPhotos.push({url: '', photo: undefined})
                }
                setBoxPhotos(_boxPhotos)
            }
        }
    }

    const handleDeleteItemPhoto = () => {
      if (props.editableItem && props.editableItem.image?.item) {
        setDeletedImages({...deletedImages, itemImage: true})
      }
      setItemUrl()
      setItemPhoto()
    };

    const handleDeleteInvoicePhoto = () => {
      if (props.editableItem && props.editableItem.image?.invoice) {
        setDeletedImages({...deletedImages, invoiceImage: true})
      }
      setInvoicePhoto()
      setInvoiceUrl()
    };

    const handleDeleteBoxPhoto = (index) => {
      return () => {
        const _boxPhotos = [...boxPhotos]
        console.log(props.editableItem.image?.boxImages[index], deletedImages.boxImages.indexOf(index) )
        if (props.editableItem && props.editableItem.image?.boxImages[index] && deletedImages.boxImages.indexOf(index) < 0) {
          setDeletedImages({...deletedImages, boxImages: [...deletedImages.boxImages, index]})
        }
        if (index > -1) {
          _boxPhotos.splice(index, 1)
          setBoxPhotos([..._boxPhotos])
        }
      }
    };

  return (
    <div>
      <Dialog onClose={handleAddProductClose} fullWidth={true}
        maxWidth={"md"} aria-labelledby="customized-dialog-title" open={props.addItemOpen}>
        <DialogTitle id="customized-dialog-title" onClose={handleAddProductClose}>
          Add Product
        </DialogTitle>
        <DialogContent dividers>
            <Container sx={classes.body}>
                <Container maxWidth={"md"} >
                  <Stack direction="row" justifyContent="space-between">
                    <Box sx={{width:'45%'}}>
                        <TextField
                            sx={classes.textEl}
                            variant="standard"
                            value={sku}
                            fullWidth={true}
                            id="standard-basic"
                            label="SKU"
                            onChange={(e)=>{setSku(e.target.value)}}
                        />
                        <TextField 
                            sx={classes.textEl}
                            variant="standard"
                            value={purchasePrice}
                            fullWidth={true}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            id="item-price"
                            label="Purchase Price"
                            onChange={(e)=>{
                              let onlyNums = e.target.value.replace(/[^0-9]/g, "");
                              if (onlyNums.length > 1) {
                                onlyNums = onlyNums.replace(/^0+/, "");
                              }
                              setPurchasePrice(onlyNums)}
                            }
                        />                    
                        <FormControlLabel
                            style={{marginTop:'25px'}}
                            control={
                                <Switch
                                    checked={isAvailable}
                                    onChange={(e)=>{setIsAvailable(e.target.checked)}}
                                    name="checkedB"
                                    color="primary"
                                />
                            }
                            label="Available"
                        />                  
                    </Box>
                    <Box sx={{width:'45%', display: 'flex', flexDirection: 'column'}} >
                        <Box sx={{mb: 1}}>
                            <Typography sx={{mb: 0.5}}>Item Photo</Typography>
                            <ImageUpload
                                avatarUrl={itemUrl}
                                setFile={setItemPhoto}
                                label="Item Photo"
                                size="small"
                                setAvatarUrl={setItemUrl}
                                setCropOpen={setCropOpen}
                                aspectRatio={4/5}
                                onDelete={handleDeleteItemPhoto}
                                isSquare
                                type="item"
                            />
                        </Box>
                        <Box sx={{mb: 1}}>
                            <Typography sx={{mb: 0.5}}>Invoice Photo</Typography>
                            <ImageUpload
                                avatarUrl={invoiceUrl}
                                setFile={setInvoicePhoto}
                                label="Invoice Photo"
                                size="small"
                                setAvatarUrl={setInvoiceUrl}
                                setCropOpen={setCropOpen}
                                aspectRatio={4/5}
                                onDelete={handleDeleteInvoicePhoto}
                                isSquare
                                element="invoice"
                                type="document"
                            />
                        </Box>
                        <Box sx={{mb: 1}}>
                            <Typography sx={{mb: 0.5}}>Box Photo</Typography>
                            <Stack direction="row" spacing={2}>
                                {boxPhotos.map((boxPhoto, index) =>{
                                    return (
                                        <ImageUpload
                                            avatarUrl={boxPhoto.url}
                                            setFile={handleBoxPhotosChange(index)}
                                            label="Box Photo"
                                            size="small"
                                            setAvatarUrl={handleBoxPhotosChange(index)}
                                            setCropOpen={setCropOpen}
                                            aspectRatio={4/5}
                                            onDelete={handleDeleteBoxPhoto(index)}
                                            isSquare
                                            element={`box-${index}`}
                                            type="box"
                                        />)
                                    })
                                }
                            </Stack>
                        </Box>
                    </Box>             
                  </Stack>
                </Container>
            </Container>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddProductClose} color="secondary">
            Cancel
          </Button>
          <Button autoFocus onClick={handleClick()} color="primary">
            {saveTitle}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

